import { ready } from '~/core';
import { retach } from '~/utils';
import { screen, addEvents, media, createElement } from '~/utils';

ready('headerMain', '.headerMain', headerMain => {
	const body = document.querySelector('body');
	const navMainOpen = headerMain.querySelector('.headerMain-navMainToggle');
	const navMainClose = headerMain.querySelector('.headerMain-navMainClose');
	const searchContainer = headerMain.querySelector('.headerMain-search');
	const searchToggle = headerMain.querySelector('.headerMain-searchToggle');
	const navMainItems = [...headerMain.querySelectorAll('.headerMain-navMainItem')];
	const tabbables = [...headerMain.querySelectorAll('.headerMain-navMain a, .headerMain-navMain button, .headerMain-navMainClose')]

	const openNav = () => {
		body.classList.add('nav-open');
		tabbables.forEach(t => t.setAttribute('tabindex', 0))
	};
	const closeNav = () => {
		body.classList.remove('nav-open');
		tabbables.forEach(t => t.setAttribute('tabindex', '-1'))
		navMainItems.forEach(navMainItem => {
			navMainItem.classList.remove('is-expanded');
		});
	};
	const cleanNav = () => {
		body.classList.remove('nav-open');
		tabbables.forEach(t => t.setAttribute('tabindex', '-1'))
	};
	const toggleSubs = () => {
		navMainItems.forEach(navMainItem => {
			const links = [...navMainItem.querySelectorAll('a')];
			addEvents(links, 'click.stop.immediate enter.stop.immediate', () => {
				return true;
			});

			addEvents(navMainItem, 'click enter space', function (e) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				const sibs = [...navMainItem.parentNode.children].filter(s => s !== this);
				sibs.forEach(sib => sib.classList.remove('is-expanded'));
				if (this.classList.contains('has-children')) {
					navMainItem.classList.toggle('is-expanded');
					document.activeElement.blur();
				}
			})
			addEvents(navMainItem, 'focusin', function (e) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				const sibs = [...navMainItem.parentNode.children].filter(s => s !== this);
				sibs.forEach(sib => sib.classList.remove('is-expanded'));
			})
			// navMainItem.addEventListener('focusin', e => {
			// 	if (!document.body.classList.contains('is-usingMouse')) {
			// 		e.stopPropagation();
			// 		const sibs = [...navMainItem.parentNode.children].filter(s => s !== this);
			// 		sibs.forEach(sib => sib.classList.remove('is-expanded'));
			// 		if (navMainItem.classList.contains('has-children')) {
			// 			navMainItem.classList.add('is-expanded');
			// 		}
			// 	}
			// });
			// navMainItem.addEventListener('focusout', e => {
			// 	if (!document.body.classList.contains('is-usingMouse')) {
			// 		e.stopPropagation();
			// 		const sibs = [...navMainItem.parentNode.children].filter(s => s !== this);
			// 		sibs.forEach(sib => sib.classList.remove('is-expanded'));
			// 		if (navMainItem.classList.contains('has-children')) {
			// 			navMainItem.classList.remove('is-expanded');
			// 		}
			// 	}
			// });
		});
	};
	const mobileBacklinks = () => {
		navMainItems.forEach(navMainItem => {
			if (navMainItem.querySelector('.headerMain-navMainSub')) {
				navMainItem.classList.add('has-children');
				const subMenu = navMainItem.querySelector('.headerMain-navMainSub');
				let backLink = subMenu.querySelector('.headerMain-navMainSubItem--back');
				if (!media.lg.matches && !backLink) {
					let backLink = createElement(
						'li',
						{
							class: 'headerMain-navMainSubItem headerMain-navMainSubItem--back',
						},
						'Back'
					);
					subMenu.prepend(backLink);
					backLink.addEventListener('click', function (e) {
						e.stopPropagation();
						this.closest('.headerMain-navMainItem').classList.remove('is-expanded');
					});
				} else if (media.lg.matches && backLink) {
					backLink.remove();
				}
			}
		});
	};
	const navInit = () => {
		cleanNav();
		addEvents(navMainClose, 'enter', closeNav)
		if (media.lg.matches) {
			navMainClose.removeEventListener('click', closeNav);
			navMainOpen.removeEventListener('click', openNav);
			tabbables.forEach(t => t.setAttribute('tabindex', 0))
		} else {
			navMainClose.addEventListener('click', closeNav);
			navMainOpen.addEventListener('click', openNav);
		}
	};

	const stickHeader = () => {
		let alreadyStuck = headerMain.classList.contains('is-stuck');
		if (!alreadyStuck) {
			headerMain.classList.add('is-sticking');
			body.style.paddingTop = headerMain.offsetHeight + 'px';
			setTimeout(() => {
				headerMain.classList.add('is-stuck');
				headerMain.classList.remove('is-sticking');
			}, 500);
		}
	}

	const unstickHeader = () => {
		headerMain.classList.remove('is-stuck');
		body.style.paddingTop = 0;
	}

	// window resize with debounce
	let scrollTimer;
	window.addEventListener('scroll', () => {
		clearTimeout(scrollTimer);
		scrollTimer = setTimeout(() => {
			if (window.scrollY > headerMain.offsetHeight * 1.25) {
				stickHeader();
			} else {
				unstickHeader();
			}
		}, 250);
	});

	window.addEventListener('resize', navInit);
	navInit();
	window.addEventListener('resize', mobileBacklinks);
	mobileBacklinks();
	toggleSubs();
	document.addEventListener(
		'click',
		function (e) {
			if (!e.target.matches('.headerMain-navMainToggle')) {
				if (!media.lg.matches)
					closeNav();
			}
		},
		false
	);

	addEvents(searchToggle, 'click.stop.prevent enter.stop.prevent', function (e) {
		let searchInput = document.querySelector('.headerMain-searchformLabel');
		if (body.classList.contains('search-open')) {
			body.classList.remove('search-open');
			searchToggle.focus();
		} else {
			body.classList.add('search-open');
			setTimeout(() => {
				searchInput.focus();
			}, 150);
		}
	});

	addEvents(searchContainer, 'focusout', function () {
		setTimeout(() => {
			if (!document.activeElement.closest('.headerMain-search')) {
				body.classList.remove('search-open');
			}
		}, 100)
	});

	addEvents(document, "click", (e) => {
		if (media.lg.matches) {
			closeNav();
		}
	});

	retach('.headerMain-search', {
		destination: '.headerMain-inner',
		mediaQuery: 992,
	});
});
